import { token } from '@atlaskit/tokens';
import styled from 'styled-components';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const QuickCopyContainer = styled.div({
  margin: `0 0 0 ${token('space.025')}`,
  maxHeight: '16px',
  cursor: 'pointer',
});
